import { render, staticRenderFns } from "./textShow.vue?vue&type=template&id=2a91bd80&scoped=true"
import script from "./textShow.vue?vue&type=script&lang=js"
export * from "./textShow.vue?vue&type=script&lang=js"
import style0 from "./textShow.vue?vue&type=style&index=0&id=2a91bd80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a91bd80",
  null
  
)

export default component.exports